import React from 'react'
import privacyData from '../../src/data/content/privacyData.json'

const PrivacyPage: React.FC = () => {
  return (
    <>
      <div className='bg-redpink text-white uppercase text-center lg:text-2xl py-2 mb-0'>
        Politique de Confidentialité
      </div>

      <div className='bg-grisclair mb-8 overflow-x-auto'>
        <div className='max-w-7xl mx-auto px-2 lg:px-0'>
          <nav className='flex space-x-6 py-4 text-sm md:text-sm'>
            {privacyData.sections.map(section => (
              <a
                key={section.id}
                href={`#${section.id}`}
                className='text-anthracite whitespace-nowrap hover:text-redpink transition-colors duration-200'
              >
                {section.title.split('. ')[1]}
              </a>
            ))}
          </nav>
        </div>
      </div>

      <article className='mx-auto max-w-7xl px-2 lg:px-0'>
        <div className='mb-8'>
          <p className='text-sm text-gray-500 mb-4'>
            Dernière mise à jour : {privacyData.lastUpdate}
          </p>
          <p className='text-anthracite'>{privacyData.introduction}</p>
        </div>

        <div className='space-y-8'>
          {privacyData.sections.map(section => (
            <section key={section.id} id={section.id} className='scroll-mt-20'>
              <h2 className='text-lg md:text-xl lg:text-2xl font-semibold text-redpink mb-4 md:mb-6'>
                {section.title}
              </h2>
              <div className='bg-grisclair p-4 md:p-6 rounded-lg'>
                {section.content.map((item, index) => (
                  <React.Fragment key={index}>
                    {index === 0 ? (
                      <p className='font-medium text-anthracite mb-3'>{item}</p>
                    ) : (
                      <p className='text-gray-600 ml-4 mb-2'>{item}</p>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </section>
          ))}
        </div>

        <footer className='mt-12 pt-8 border-t border-gray-200 mb-8'>
          <div className='text-gray-600 mb-4'>
            {privacyData.footer.contact.text}{' '}
            <a
              href={privacyData.footer.contact.link.url}
              className='text-redpink hover:text-redpinkDark transition-colors duration-200'
            >
              {privacyData.footer.contact.link.text}
            </a>
          </div>
          <p className='text-sm text-gray-500 italic'>
            {privacyData.footer.disclaimer}
          </p>
        </footer>
      </article>
    </>
  )
}

export default PrivacyPage
